import React, {ComponentProps} from 'react';
import {gql} from '@apollo/client';
import {IntercomProvider} from 'react-use-intercom';
import {useEnvironment} from './Environment';
import {Intercom as Identity} from '../__generated__/Intercom';
import isNil from '../util/isNil';
import useEzManagePermissions from './useEzManagePermissions';

export const intercomFragment = gql`
  fragment Intercom on Identity {
    id
    catererAccount {
      id
      trackingId
      email
      name
      hasUnregisteredPayoneerBusiness
    }
  }
`;

interface Props extends Omit<ComponentProps<typeof IntercomProvider>, 'appId'> {
  me?: Identity;
}

const Intercom = ({me, ...props}: Props) => {
  const permissions = useEzManagePermissions();
  const canManageDemoData = permissions.data?.ezManagePermissions?.canManageDemographicData;
  const environment = useEnvironment();
  return (
    <IntercomProvider
      {...props}
      autoBoot
      shouldInitialize={!isNil(me?.catererAccount)}
      appId={environment.intercomAppId as string}
      autoBootProps={{
        name: me?.catererAccount?.name as string,
        email: me?.catererAccount?.email as string,
        userId: me?.catererAccount?.trackingId as string,
        customAttributes: {
          eligibleForPayoneerMessaging: me?.catererAccount?.hasUnregisteredPayoneerBusiness,
          eligibleForDemographicDataMessaging: canManageDemoData,
          'Source Website': 'supply',
        },
      }}
    />
  );
};

export default Intercom;
